import { components } from "../main/components";
import { pages } from "./pages";
import { blocks } from "./blocks";
import { partials } from "./partials";
import type { XylView } from "../../helpers/xyl-view-helpers";

export const singlePageModules: XylView[] = [...components, ...pages, ...blocks, ...partials];
